import { UpdateAdminDataType } from "../components/profile/Profile";

export const UpdateAdminData: UpdateAdminDataType = {
  firstName: "",
  lastName: "",
  password: "",
  confirmPassword: "",
  user_role: "",
  email: "",
  status: "",
  designation: "",
  department: "",
};
